module.exports = __webpack_public_path__ + "static/media/clean_after_construction.2d8dab42.svg";